import { CurrencyPipe } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { KioskService } from "src/app/core/services/kiosk.service";
import { PromoCodeValidationRequestDto, PromoCodeValidationResponseDto } from "src/app/shared/models/DTO/promo-code-validation.dto";
import { AppMessageSeverity } from "src/app/shared/models/enums/AppMessageSeverity.enum";
import { TransactionType } from "src/app/shared/models/enums/transaction-types.enum";
import { OrderItem } from "src/app/shared/models/order";

@Component({
	selector: "app-kiosk-promo-code-select",
	templateUrl: "./kiosk-promo-code-select.component.html",
	styleUrls: ["../../../kiosk.styles.scss"],
	providers: [CurrencyPipe],
})
export class KioskPromoCodeSelectComponent implements OnInit {
	@Input() promoCodeComplete: boolean;
	@Output() promoCodeCompleteChange = new EventEmitter<boolean>();

	promoCodeCode: string;
	rejectionMessage: string;

	constructor(public kioskService: KioskService, private focuslink: FocuslinkService, private currencyPipe: CurrencyPipe) {}

	ngOnInit(): void {}

	async onCodeEntry() {
		if (this.promoCodeCode) {
			this.kioskService.app.loading(true);
			this.validatePromoCode(this.promoCodeCode);
		} else {
			this.kioskService.app.msgSvc.add({ severity: AppMessageSeverity.YELLOW, summary: "", detail: `Please enter a promo code.` });
		}
	}

	async validatePromoCode(code: string) {
		const resp = await this.focuslink.promoCodeValidate(
			this.kioskService.venueService.venueKey,
			new PromoCodeValidationRequestDto({
				transactionType: TransactionType.KIOSK,
				checkAmount: this.kioskService.activeOrder.value.total,
				checkDate: this.kioskService.app.moment().format(),
				checkKey: this.kioskService.activeOrder.value.checkKey,
				menuItemKeys: this.kioskService.activeOrder.value.seats[0].items.map((i) => i.menuItemKey),
				promoCode: code,
			})
		);

		const validationResponse = new PromoCodeValidationResponseDto(resp);
		let appliedAmount: number = 0;
		if (validationResponse.rejectionResonseReason) {
			this.rejectionMessage = validationResponse.rejectionMessage;
		} else {
			validationResponse.appliedPromoCodes.forEach((code) => {
				appliedAmount += code.value;
				this.kioskService.kioskOrderAddItem(
					new OrderItem({
						menuItemKey: code.menuItemKey,
						name: `Promo Code: ${this.promoCodeCode}`,
						price: code.value,
						quantity: 1,
						priceNumber: 1,
						modifiers: [],
					})
				);
			});

			this.rejectionMessage = `Congrats! You saved ${this.currencyPipe.transform(-appliedAmount)}!`;

			this.kioskService.kioskOrderRecalculateTotals();
			this.promoCodeCompleteChange.emit(true);
		}

		this.kioskService.app.loading(false);
	}
}
